var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlfin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 111,
    height: 48,
    viewBox: "0 0 111 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 20.2259V3.9047C1 3.1931 1.17791 2.547 1.53374 1.9664C1.88957 1.3671 2.35776 0.889601 2.93832 0.533701C3.53761 0.177901 4.19308 0 4.90473 0H17.2931C18.0048 0 18.6602 0.177901 19.2595 0.533701C19.8588 0.889601 20.3364 1.3671 20.6922 1.9664C21.048 2.547 21.2259 3.1931 21.2259 3.9047V20.2259H17.4898V13.4278H4.70809V20.2259H1ZM4.70809 9.7197H17.4898V4.0733C17.4898 3.9796 17.4523 3.9047 17.3774 3.8485C17.3025 3.7736 17.2182 3.7362 17.1246 3.7362H5.04519C4.95155 3.7362 4.86728 3.7736 4.79237 3.8485C4.73618 3.9047 4.70809 3.9796 4.70809 4.0733V9.7197Z",
    fill: "url(#paint0_linear_1_2)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46 20.2259V0H64.6247V3.7362H49.7362V8.2308H64.6247V11.9951H49.7362V16.4898V18V20.2259H46Z",
    fill: "url(#paint1_linear_1_2)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3447 20.2259V0H26.5H28.0809V8.23084V9.5V11V16.4898H42.9694V20.2259H24.3447Z",
    fill: "url(#paint2_linear_1_2)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M67 20.2259V0H69.1553H70.7362V8.23084V9.5V11V16.4898V18V20.2259H67Z",
    fill: "url(#paint3_linear_1_2)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M74 20.2259V0H78.0733L90.4898 14.7762V0H94.226V20.2259H90.1527L77.7081 5.42168V20.2259H74Z",
    fill: "url(#paint4_linear_1_2)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_2",
    x1: 11.113,
    y1: 0,
    x2: 11.113,
    y2: 20.2259,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#D442F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999999"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_2",
    x1: 55.3124,
    y1: 0,
    x2: 55.3124,
    y2: 20.2259,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF56F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B936EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_2",
    x1: 0.999731,
    y1: 0.00000638634,
    x2: 78.8458,
    y2: 9.73774,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.183111,
    stopColor: "#FF56F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.432593,
    stopColor: "#B936EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.854443,
    stopColor: "#3BACE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#406AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1_2",
    x1: 43.655,
    y1: 0.00000665001,
    x2: 121.501,
    y2: 9.73774,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.183111,
    stopColor: "#FF56F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.432593,
    stopColor: "#B936EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.854443,
    stopColor: "#3BACE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#406AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1_2",
    x1: 29.2036,
    y1: 0.00000112632,
    x2: 107.05,
    y2: 9.73773,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.183111,
    stopColor: "#FF56F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.432593,
    stopColor: "#B936EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.854443,
    stopColor: "#3BACE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#406AFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlfin);
export default __webpack_public_path__ + "static/media/Alfin.0070819ed6f0aee583f349a0148d4126.svg";
export { ForwardRef as ReactComponent };